<template>
  <gat-flex :size="size" :hide="hide">
    <gat-field-spacer :size="size">
      <v-autocomplete
        :items="items"
        :label="label"
        v-model="itemValue"
        @input="updateValue()"
        :item-text="textFieldName"
        :item-value="codeFieldName"
        :error-messages="errorMsg"
        :readonly="isReadonly"
      ></v-autocomplete>
    </gat-field-spacer>
  </gat-flex>
</template>

<script>
import GatFlex from "./GatFlex.vue";
import GatFieldSpacer from "./GatFieldSpacer.vue";
export default {
  name: "GatSelect",
  components: { GatFlex, GatFieldSpacer },
  inject: ["getGroupReadonly"],
  props: [
    "items",
    "label",
    "value",
    "size",
    "textFieldName",
    "codeFieldName",
    "errorMsg",
    "readonly",
    "hide",
  ],
  data: function () {
    return {
      itemValue: undefined,
    };
  },

  watch: {
    value: function (newValue) {
      this.itemValue = newValue;
    },
  },

  computed: {
    isReadonly() {
      if (typeof this.readonly != "undefined") {
        return this.readonly;
      } else {
        return this.getGroupReadonly();
      }
    },
  },

  methods: {
    updateValue() {
      this.$emit("input", this.itemValue);
    },
  },
};
</script>

<style scoped></style>
